<script lang="ts">
  import Background from "./Background.svelte";
  import GiftsContainer from "./GiftsContainer.svelte";
  import ExtraObjectsContainer from "./ExtraObjectsContainer.svelte";
  import AnimationsContainer from "./AnimationsContainer.svelte";
  import { afterUpdate } from "svelte";
  import { CurrentDay, assetsLoaded } from "../store/AppState";
  import NavigationControls from "./NavigationControls.svelte";

  let backgroundLoaded = false;
  let animationsLoaded = false;
  let giftsLoaded = false;
  let extraObjectsLoaded = false;

  let scrolledToGift = false;

  const onBackgroundLoad = () => {
    backgroundLoaded = true;
  };
  const onAnimationsLoad = () => {
    animationsLoaded = true;
  };
  const onGiftsLoad = () => {
    giftsLoaded = true;
  };
  const onExtraObjectsLoad = () => {
    extraObjectsLoaded = true;
  };

  $: allLoaded =
    backgroundLoaded &&
    animationsLoaded &&
    (giftsLoaded || (window.isClosed && !window.isShowroom)) &&
    extraObjectsLoaded;

  let scene: HTMLElement;
  afterUpdate(() => {
    if (allLoaded) {
      $assetsLoaded = true;
    }
    if ($assetsLoaded && !scrolledToGift) {
      if (window.isClosed && !window.isShowroom) {
        return;
      }
      const gifts = scene.getElementsByClassName("gift-hitbox");

      gifts[$CurrentDay - 1].scrollIntoView({
        behavior: "instant",
        block: "nearest",
        inline: "center",
      });
    }
  });
</script>

<div
  bind:this={scene}
  class="scene"
  style={`--visibility: ${$assetsLoaded ? "visible" : "hidden"}`}
>
  <Background onLoad={() => onBackgroundLoad()} />
  <AnimationsContainer onLoad={() => onAnimationsLoad()} />
  {#if !window.isClosed || window.isShowroom}
    <GiftsContainer onLoad={() => onGiftsLoad()} />
  {/if}
  <ExtraObjectsContainer onLoad={() => onExtraObjectsLoad()} />
  <NavigationControls />
</div>

<style>
  .scene {
    height: 100%;
    display: inline-block;
    position: relative;
    overflow: clip;
    visibility: var(--visibility);
  }
</style>
